import React, { createContext, useContext } from 'react';
import { FetchActiveI9ItemsUseCase } from '../../application/use-cases/FetchActiveI9ItemsUseCase';
import { ApiActiveI9Repository } from '../repositories/ApiActiveI9Repository';
import { useHttpClientCore } from '@/shared';
import { ArchiveI9UseCase } from '@/shared/application/use-cases/ArchiveI9UseCase';
import { ApiArchiveI9Repository } from '@/shared/infra/repositories/ApiArchiveI9Repository';

interface IActiveI9DIContext {
  fetchActiveI9ItemsUseCase: FetchActiveI9ItemsUseCase;
  archiveI9UseCase: ArchiveI9UseCase;
}

const ActiveI9DIContext = createContext<IActiveI9DIContext | undefined>(undefined);

export const ActiveI9DIProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiActiveI9Repository(httpClient);
  const fetchActiveI9ItemsUseCase = new FetchActiveI9ItemsUseCase(repository);
  const archiveI9UseCase = new ArchiveI9UseCase(new ApiArchiveI9Repository(httpClient));

  return (
    <ActiveI9DIContext.Provider value={{ fetchActiveI9ItemsUseCase, archiveI9UseCase }}>
      {children}
    </ActiveI9DIContext.Provider>
  );
};

export function useActiveI9DIContext() {
  const ctx = useContext(ActiveI9DIContext);
  if (!ctx) throw new Error('useActiveI9DIContext must be used within ActiveI9DIProvider');
  return ctx;
}
